import { DOUBLE, ZERO } from "../../../../constants/numbers.consts.js";
// import hooks
import { useState, useEffect } from "react";
import scrollElementIntoView from "../../../../client-utils/element/scrollElementIntoView.util.js";
import isElementInView from "../../../../client-utils/element/isElementInView.util.js";
export const useCalculatePosition = ({ elementSelector, paperWidth, paperHeight, offset, }) => {
    const [elementPosition, setElementPosition] = useState({
        top: ZERO,
        left: ZERO,
        width: ZERO,
        height: ZERO,
    });
    const [tooltipPosition, setTooltipPosition] = useState({
        top: ZERO,
        left: ZERO,
    });
    const updatePosition = async () => {
        try {
            const element = elementSelector();
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;
            if (element) {
                if (!isElementInView(element)) {
                    await scrollElementIntoView({
                        element,
                        scrollTime: 400,
                    });
                }
                const rect = element.getBoundingClientRect();
                // Calculate available space
                const spaceAbove = rect.top;
                const spaceBelow = windowHeight - (rect.top + rect.height);
                const spaceLeft = rect.left;
                const spaceRight = windowWidth - (rect.left + rect.width);
                let tooltipTop = ZERO;
                let tooltipLeft = ZERO;
                // Determine optimal position
                if (spaceRight >= paperWidth) {
                    // Place to the right
                    tooltipLeft = rect.left + rect.width + offset;
                    tooltipTop = Math.min(rect.top + rect.height / DOUBLE - paperHeight / DOUBLE, windowHeight - paperHeight);
                }
                else if (spaceLeft >= paperWidth) {
                    // Place to the left
                    tooltipLeft = rect.left - paperWidth - offset;
                    tooltipTop = Math.min(rect.top + rect.height / DOUBLE - paperHeight / DOUBLE, windowHeight - paperHeight);
                }
                else if (spaceBelow >= paperHeight) {
                    // Place below
                    tooltipLeft = Math.min(rect.left + rect.width / DOUBLE - paperWidth / DOUBLE, windowWidth - paperWidth);
                    tooltipTop = rect.top + rect.height + offset;
                }
                else if (spaceAbove >= paperHeight) {
                    // Place above
                    tooltipLeft = Math.min(rect.left + rect.width / DOUBLE - paperWidth / DOUBLE, windowWidth - paperWidth);
                    tooltipTop = rect.top - paperHeight - offset;
                }
                else {
                    // Fallback: Position diagonally below-right
                    tooltipLeft = Math.min(rect.left + rect.width + offset, windowWidth - paperWidth);
                    tooltipTop = Math.min(rect.top + rect.height + offset, windowHeight - paperHeight);
                }
                // Clamp values to prevent overflow
                tooltipLeft = Math.max(offset, Math.min(tooltipLeft, windowWidth - paperWidth - offset));
                tooltipTop = Math.max(offset, Math.min(tooltipTop, windowHeight - paperHeight - offset));
                setElementPosition({
                    top: rect.top + window.scrollY,
                    left: rect.left + window.scrollX,
                    width: rect.width,
                    height: rect.height,
                });
                setTooltipPosition({
                    top: tooltipTop + window.scrollY,
                    left: tooltipLeft + window.scrollX,
                });
            }
            else {
                // Center the tooltip when the element is null
                setElementPosition({
                    top: ZERO,
                    left: ZERO,
                    width: ZERO,
                    height: ZERO,
                });
                setTooltipPosition({
                    top: (windowHeight - paperHeight) / DOUBLE,
                    left: (windowWidth - paperWidth) / DOUBLE,
                });
            }
        }
        catch (error) {
            console.error("Error running updatePosition:", error);
        }
    };
    useEffect(() => {
        void updatePosition();
        const handleResize = () => {
            void updatePosition();
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [updatePosition]);
    return { elementPosition, tooltipPosition, updatePosition };
};
export default useCalculatePosition;
